<div class="mobi-ui-grid is-align-stretch mobi-ui-margin-y-md">
  <webform-summary-card
    [isCalculator]="true"
    [action]="calcAction"
    class="mobi-ui-col-1/1 md:mobi-ui-col-1/3"
  ></webform-summary-card>
  <webform-summary-card
    [title]="
      'summary_contract_title'
        | texts: { context: 'primcalc', default: 'Vertragsdetails' }
    "
    [entries]="contractData"
    class="mobi-ui-col-1/1 md:mobi-ui-col-1/3"
  ></webform-summary-card>
  <webform-summary-card
    [title]="
      'summary_personal_title' | texts: { context: 'primcalc', default: 'Angaben' }
    "
    [action]="personalAction"
    [entries]="personalData"
    class="mobi-ui-col-1/1 md:mobi-ui-col-1/3"
  ></webform-summary-card>
</div>
